module.exports = __webpack_public_path__ + "img/09-ABITO-ALIMINI-SML--UNITI-LINO--STAMPE-LINO7.47ed8131.jpg";